import * as React from 'react'
import { Button } from '@mui/material'

export const CustomButton = (props) => {

  return (
    <Button
      sx={{ padding: '5px 10px', height: '40px' }}
      style={props.style}
      size="small" 
      color="primary"
      disabled={props.disabled}
      onClick={props.onClick}
      variant="contained"
      startIcon={props.startIcon}
    >
      {props.title}
    </Button>
  );
};
